import { registerVolunteerForEventAsPartner } from '@/services/webApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useRegisterVolunteerForEventAsPartnerMutation({
  eventId,
  onSuccess,
  onError
}: {
  eventId: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['registerVolunteerForEventAsPartner', eventId],
    mutationFn: registerVolunteerForEventAsPartner,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['event', eventId]
      });
      queryClient.invalidateQueries({
        queryKey: ['eventRegistrationCount', eventId]
      });
      queryClient.invalidateQueries({
        queryKey: ['organizationVolunteersCount']
      });
      queryClient.invalidateQueries({
        queryKey: ['organizationEventVolunteers', eventId]
      });

      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    }
  });
}
